<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";

    import {mixedChart, linewithDataChart} from "./data-company";
    import Stat from "@/components/widgets/stat";

    /**
     * Contacts-Profile component
     */
    export default {
        page: {
            title: "Company report",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader, Stat},
        data() {
            return {
                mixedChart: mixedChart,
                linewithDataChart: linewithDataChart,
                title: "Company report",
            };
        }
    };
</script>

<template>
    <Layout>
        <PageHeader :title="title"/>
        <div class="row">
            <div class="col-xl-4">
                <div class="card overflow-hidden">
                    <div class="bg-soft-primary">
                        <div class="row">
                            <div class="col-7">
                                <div class="text-primary p-3 mb-2">
                                    <h5 class="text-primary">Web Monkeys B.V.</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body pt-0">
                        <div class="row">
                            <div class="col-sm-4">
                                <div class="avatar-md profile-user-wid mb-4">
                                    <img
                                            src="@/assets/images/company-logo.png"
                                            alt
                                            class="img-thumbnail rounded-circle"
                                    />
                                </div>
                            </div>

                            <div class="col-sm-8">
                                <div class="pt-4">
                                    <div class="row">
                                        <div class="col-5">
                                            <h5 class="font-size-15">KVK</h5>
                                            <p class="text-muted mb-0">12345678</p>
                                        </div>
                                        <div class="col-7">
                                            <h5 class="font-size-15">BTW</h5>
                                            <p class="text-muted mb-0">NL999999999B01</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mb-0">
                            <a href class="btn btn-primary btn-sm">
                                Export report
                                <i class="bx bx-export ml-1"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <!-- end card -->

                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title mb-4">FTE & Headcount</h4>

                        <div class="table-responsive mb-2">
                            <table class="table">
                                <tbody>
                                <tr>
                                    <th scope="row">Headcount:</th>
                                    <td>52</td>
                                </tr>
                                <tr>
                                    <th scope="row">Employees :</th>
                                    <td>42,5 FTE</td>
                                </tr>
                                <tr>
                                    <th scope="row">External :</th>
                                    <td>6 FTE</td>
                                </tr>
                                <tr class="table-light">
                                    <th scope="row">Total :</th>
                                    <td>48,5 FTE</td>
                                </tr>
                                <tr>
                                    <th scope="row">Vacant positions :</th>
                                    <td>4</td>
                                </tr>

                                </tbody>
                            </table>
                        </div>
                        <div class="mb-0">
                            <router-link to="/users" class="btn btn-primary btn-sm">
                                Go to registry
                                <i class="bx bx-user ml-1"></i>
                            </router-link>
                        </div>
                    </div>
                </div>
                <!-- end card -->

                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title mb-4">FTE budget (this year)</h4>

                        <div class="table-responsive mb-2">
                            <table class="table">
                                <tbody>
                                <tr>
                                    <th scope="row">Budget :</th>
                                    <td>€2.700.000,-</td>
                                </tr>
                                <tr>
                                    <th scope="row">Actual :</th>
                                    <td>€2.923.600,-</td>
                                </tr>
                                <tr class="table-warning">
                                    <th scope="row">Balance :</th>
                                    <td>-€223.600</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="mb-0">
                            <a href class="btn btn-primary btn-sm">
                                Go to accounting
                                <i class="mdi mdi-arrow-right ml-1"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <!-- end card -->

                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title mb-4">Employees</h4>

                        <div class="table-responsive mb-2">
                            <table class="table">
                                <tbody>
                                <tr>
                                    <td>Klaas Jansen</td>
                                </tr>
                                <tr>
                                    <td>Demi Schools</td>
                                </tr>
                                <tr>
                                    <td>Joost Pieters</td>
                                </tr>
                                <tr>
                                    <td>...</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="mb-0">
                            <router-link to="/users" class="btn btn-primary btn-sm">
                                Go to registry
                                <i class="bx bx-user ml-1"></i>
                            </router-link>
                        </div>
                    </div>
                </div>
                <!-- end card -->

            </div>

            <div class="col-xl-8">
                <!-- absenteeism -->
                <div class="row">
                    <div class="col-md-4">
                        <Stat icon="bx bxs-calendar-plus" title="Average overtime (weekly)" value="1,5 hours"/>
                    </div>
                    <div class="col-md-4">
                        <Stat icon="bx bx-dizzy" title="Average absentee (yearly)" value="7,7 days"/>
                    </div>
                    <div class="col-md-4">
                        <Stat icon="bx bx-bar-chart-square" title="Average absentee rate" value="3,5%"><i class="bx bx-trending-up text-danger"></i></Stat>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title mb-4">Objectives & Key results</h4>
                        <div class="table-responsive mb-0">
                            <table class="table table-nowrap table-hover">
                                <thead>
                                <tr>
                                    <th scope="col">Quarter</th>
                                    <th scope="col">Objective</th>
                                    <th scope="col">Progress</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>Q2 2020</td>
                                    <td>Increase customer satisfaction by 10%.</td>
                                    <td>100%</td>
                                </tr>
                                <tr>
                                    <td>Q2 2020</td>
                                    <td>Deliver all customer product 10% faster than last quarter.</td>
                                    <td>70%</td>
                                </tr>
                                <tr>
                                    <td>Q3 2020</td>
                                    <td>Be a web development leader and authority.</td>
                                    <td>20%</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="mb-0">
                            <a href class="btn btn-primary btn-sm">
                                Add OKRs
                                <i class="mdi mdi-plus ml-1"></i>
                            </a>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <h4 class="card-title mb-0">Absenteeism (last 5 years)</h4>
                                <div id="revenue-chart" class="apex-charts"></div>
                                <apexchart
                                        class="apex-charts"
                                        height="350"
                                        type="line"
                                        dir="ltr"
                                        :series="mixedChart.series"
                                        :options="mixedChart.chartOptions"
                                ></apexchart>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <h4 class="card-title mb-4">Overtime yearly average (hourly/employee) </h4>
                                <apexchart
                                        class="apex-charts"
                                        height="380"
                                        type="line"
                                        dir="ltr"
                                        :series="linewithDataChart.series"
                                        :options="linewithDataChart.chartOptions"
                                ></apexchart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- end row -->
    </Layout>
</template>